<template>
  <div>
    <div class="position-relative">
      <!-- shape Hero -->
      <section class="section-shaped my-0">
        <div class="shape shape-style-1 bg-gradient-primary shape-skew">
          <span></span>
          <span></span>
          <span></span>
          <span></span>
          <span></span>
          <span></span>
          <span></span>
          <span></span>
          <span></span>
          <span></span>
        </div>
        <div class="container shape-container d-flex">
          <div class="col px-0">
            <div class="row">
              <div class="col-lg-4">
                <card
                  class="border-0 d-flex card-mnlb"
                  hover
                  shadow
                  body-classes="text-center align-items-center d-flex justify-content-center"
                >
                  <object
                    data="/img/svg/12-MBLB.svg"
                    type="image/svg+xml"
                    class="text-white card-pajak"
                  ></object>
                  <h6
                    class="text-white text-uppercase title-inside-card"
                    style="margin-top: 7px"
                  >
                    PAJAK MBLB
                  </h6>
                </card>
              </div>
              <div class="col-lg-8">
                <h1 class="display-3 text-white">
                  Pelayanan Mineral Bukan Logam Batuan
                  <span>Kabupaten Ketapang</span>
                </h1>
                <p class="description mt-3 text-white">
                  Pajak Mineral Bukan Logam dan Batuan adalah pajak atas
                  kegiatan pengambilan mineral bukan logam dan batuan, baik dari
                  sumber alam di dalam dan/atau permukaan bumi untuk
                  dimanfaatkan. Mineral Bukan Logam dan Batuan adalah mineral
                  bukan logam dan batuan sebagaimana dimaksud di dalam peraturan
                  perundang-undangan di bidang mineral dan batubara.
                </p>

                <p class="description mt-3 text-white">
                  Besaran pokok Pajak Mineral Bukan Logam dan Batuan yang
                  terutang dihitung dengan cara mengalikan tarif dengan dasar
                  pengenaan pajak.
                </p>

                <div class="btn-wrapper">
                  <base-button
                    tag="a"
                    class="mb-3 mb-sm-0"
                    type="info"
                    textColor="white"
                    icon="fa fa-arrow-left"
                    @click="goback()"
                    >Kembali</base-button
                  >
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <!-- 1st Hero Variation -->
    </div>
    <br>
    <br>
    <section class="section section-lg pt-lg-0 mt--200">
      <div class="container">
        <div class="row justify-content-center">
          <div class="col-lg-12">
            <div class="row row-grid">
              <div class="col-md-3" v-if="checkAkses">
                <card class="border-0" hover shadow body-classes="py-5">
                  <icon name="fa fa-save" type="success" rounded class="mb-4"></icon>
                  <h6 class="text-success text-uppercase">E-SPTPD</h6>
                  <p class="description mt-3">Pendataan SPTPD Pajak Mineral Bukan Logam dan Batuan secara Online.</p>
                  <base-button
                    textColor="white"
                    tag="a"
                    type="success"
                    class="mt-4"
                    @click="goSptpdPajak()"
                  >E-SPTPD</base-button>
                </card>
              </div>
              <div class="col-md-3" v-if="checkAkses">
                <card class="border-0" hover shadow body-classes="py-5">
                  <icon name="fa fa-cog" type="danger" rounded class="mb-4"></icon>
                  <h6 class="text-danger text-uppercase">Cetak SSPD</h6>
                  <p class="description mt-3">Cetak SSPD Pajak Mineral Bukan Logam dan Batuan.</p>
                  <base-button
                    tag="a"
                    textColor="white"
                    type="warning"
                    class="mt-4"
                    @click="cetakSSPD()"
                  >Cetak</base-button>
                </card>
              </div>
              <div class="col-md-3" v-if="checkAkses">
                <card class="border-0" hover shadow body-classes="py-5">
                  <icon
                    name="fa fa-print"
                    type="success"
                    rounded
                    class="mb-4"
                  ></icon>
                  <h6 class="text-success text-uppercase">
                    Informasi Pajak Mblb
                  </h6>
                  <p class="description mt-3">
                    Melihat Informasi Pajak Mblb berdasarkan NPWPD pemilik
                    usaha.<br />
                  </p>
                  <base-button
                    textColor="white"
                    tag="a"
                    type="success"
                    class="mt-4"
                    @click="goInformasiPajak()"
                    >Informasi Pajak</base-button
                  >
                </card>
              </div>
              <div class="col-md-3">
                <card class="border-0" hover shadow body-classes="py-5">
                  <icon
                    name="fa fa-cog"
                    type="warning"
                    rounded
                    class="mb-4"
                  ></icon>
                  <h6 class="text-warning text-uppercase">
                    Peraturan Pajak Mblb
                  </h6>
                  <p class="description mt-3">
                    Dasar Hukum pemungutan Pajak Mblb yang termuat dalam
                    undang-undang.<br />
                  </p>
                  <base-button
                    tag="a"
                    textColor="white"
                    type="warning"
                    class="mt-4"
                    @click="goDasarHukum()"
                    >Dasar Hukum</base-button
                  >
                </card>
              </div>
            </div>
          </div>
        </div>

        <br />
        <br />
        <div class="row">
          <div class="col-md-12">
            <highcharts :options="chartOptions"></highcharts>
          </div>
        </div>
      </div>
    </section>
    <modal-informasi-pajak
      ref="modal-informasi-pajak"
      title="Pencarian Informasi Pajak Mblb"
      code="1111"
      url="/api/v1/pajak-daerah"
    ></modal-informasi-pajak>
    <modal
      :show.sync="dasar_hukum"
      footerClasses="text-right"
      :largeModal="true"
    >
      <h6
        slot="header"
        class="modal-title text-success font-weight-bold"
        id="modal-title-default"
      >
        Dasar Hukum Pajak Mineral Logam dan Batuan
      </h6>
      <div class="d-block">
        <div class="bodytext">
          <p><strong>Nama, Objek, Subjek dan Wajib Pajak</strong></p>

          <p>
            Setiap kegiatan pengambilan mineral bukan logam dan batuan dipungut
            pajak dengan nama Pajak Mineral Bukan Logam dan Batuan.
          </p>

          <p>
            Objek Pajak Mineral Bukan Logam dan Batuan adalah kegiatan
            pengambilan Mineral Bukan Logam dan Batuan yang meliputi :
          </p>

          <ol>
            <li>asbes;</li>
            <li>batu tulis;</li>
            <li>batu setengah permata;</li>
            <li>batu kapur;</li>
            <li>batu apung;</li>
            <li>batu permata;</li>
            <li>bentonit;</li>
            <li>dolomit;</li>
            <li>feldspar;</li>
            <li>garam batu (<em>halite</em>);</li>
            <li>grafit;</li>
            <li>granit/andesit;</li>
            <li>gips;</li>
            <li>kalsit;</li>
            <li>kaolin;</li>
            <li>leusit;</li>
            <li>magnesit;</li>
            <li>mika;</li>
            <li>marmer;</li>
            <li>nitrat;</li>
            <li>opsidien;</li>
            <li>oker;</li>
            <li>pasir dan kerikil;</li>
            <li>pasir kuarsa;</li>
            <li>perlit;</li>
            <li>phospat;</li>
            <li>talk;</li>
            <li>tanah serap (<em>fullers earth</em>);</li>
            <li>tanah diatome;</li>
            <li>tanah liat;</li>
            <li>tawas (<em>alum</em>);</li>
            <li>tras;</li>
            <li>yarosif;</li>
            <li>zeolit;</li>
            <li>basal;</li>
            <li>trakkit; dan</li>
            <li>
              mineral bukan logam dan batuan lainnya sesuai dengan ketentuan
              peraturan perundang-undangan.
            </li>
          </ol>

          <p>&nbsp;</p>

          <p>
            Adapun yang dikecualikan dari objek Pajak Mineral Bukan Logam dan
            Batuan adalah:
          </p>

          <ol>
            <li>
              kegiatan pengambilan mineral bukan logam dan batuan yang
              nyata-nyata tidak dimanfaatkan secara komersial, seperti kegiatan
              pengambilan tanah untuk keperluan rumah tangga, pemancangan tiang
              listrik/telepon, penanaman kabel listrik/telepon, penanaman pipa
              air/gas; dan
            </li>
            <li>
              kegiatan pengambilan mineral bukan logam dan batuan yang merupakan
              ikutan dari kegiatan pertambangan lainnya, yang tidak dimanfaatkan
              secara komersial.
            </li>
          </ol>

          <p>&nbsp;</p>

          <p>
            Subjek Pajak Mineral Bukan Logam dan Batuan adalah orang pribadi
            atau Badan yang dapat mengambil mineral bukan logam dan batuan.
            Wajib Pajak Mineral Bukan Logam dan Batuan adalah orang pribadi atau
            Badan yang mengambil mineral bukan logam dan batuan.
          </p>

          <p>&nbsp;</p>

          <p>
            <strong>Dasar Pengenaan, Tarif dan Cara Penghitungan Pajak</strong>
          </p>

          <ol>
            <li>
              Dasar pengenaan Pajak Mineral Bukan Logam dan Batuan adalah Nilai
              Jual Hasil pengambilan mineral bukan logam dan batuan.
            </li>
            <li>
              Nilai jual dihitung dengan mengalikan volume/tonase hasil
              pengambilan dengan nilai pasar atau harga standar masing-masing
              jenis mineral bukan logam dan batuan.
            </li>
            <li>Nilai pasar adalah harga rata-rata yang berlaku di Daerah.</li>
            <li>
              Dalam hal nilai pasar dari hasil produksi mineral bukan logam dan
              batuan sulit diperoleh, digunakan harga standar yang ditetapkan
              oleh instansi yang berwenang dalam bidang pertambangan mineral
              bukan logam dan batuan.
            </li>
            <li>
              Tarif Pajak Mineral Bukan Logam dan Batuan ditetapkan sebesar 25%
              (dua puluh lima perseratus).
            </li>
            <li>
              Besaran pokok Pajak Mineral Bukan Logam dan Batuan yang terutang
              dihitung dengan cara mengalikan tarif pajak sebagaimana dimaksud
              dalam Pasal 37 dengan dasar pengenaan pajak sebagaimana dimaksud
              dalam Pasal 36.
            </li>
          </ol>
        </div>
      </div>
    </modal>
  </div>
</template>

<script>
import ModalInformasiPajak from "../GlobalPage/InformasiPajak";
import ModalWajibPajak from "../GlobalPage/WajibPajak";
import { Chart } from "highcharts-vue";
import Swal from "sweetalert2";
import axios from "axios";
import Modal from "@/components/Modal.vue";
export default {
  name: "mblb",
  components: {
    ModalInformasiPajak,
    highcharts: Chart,
    ModalWajibPajak,
    Modal
  },
  data() {
    return {
      items: [],
      dasar_hukum: false,
    };
  },
  computed: {
    checkAkses() {
      if (this.$store.state.auth.status.loggedIn)
        if (this.$store.state.auth.user.is_wajib_pajak)
          return this.$store.state.auth.user.registrations.find((item) => item.business_id == 12)
        else
          return this.$store.state.auth.user.business_id == 12;
      return false;
    },
    chartOptions() {
      return {
        chart: {
          type: "column",
        },
        title: {
          text: "Realisasi Pajak Mblb berdasarkan Tahun",
        },
        subtitle: {
          text: "Data tahun yang di ambil adalah data 10 tahun kebelakang.",
        },
        accessibility: {
          announceNewData: {
            enabled: true,
          },
        },
        xAxis: {
          type: "category",
        },
        yAxis: {
          title: {
            text: "Jumlah Realisasi",
          },
        },
        legend: {
          enabled: false,
        },
        plotOptions: {
          series: {
            borderWidth: 0,
            dataLabels: {
              enabled: true,
              format: "{point.y:.2f}",
            },
          },
        },

        tooltip: {
          headerFormat: '<span style="font-size:11px">{series.name}</span><br>',
          pointFormat:
            '<span style="color:{point.color}">{point.name}</span>: <b>{point.y:.2f}%</b> of total<br/>',
        },

        series: [
          {
            name: "Tahun",
            colorByPoint: true,
            data: this.items,
          },
        ],
      };
    },
  },
  created() {
    this.getRealisasi();
  },
  methods: {
    async getRealisasi() {
      try {
        this.isBusy = true;
        let { data } = await axios.get("/api/v1/realisasi/mblb");

        var items = [];
        for (const [key, value] of Object.entries(data)) {
          this.items.push({
            name: value.tahun_realisasi,
            y: parseFloat(value.realisasi),
          });
        }
      } catch (error) {
        Swal.fire({
          title: "",
          text: error.message,
          type: "warning",
          showCancelButton: false,
          confirmButtonColor: "#3085d6",
          confirmButtonText: "Tutup!",
        });
      } finally {
        this.isBusy = false;
      }
    },
    goInformasiPajak() {
      this.$refs["modal-informasi-pajak"].showModal();
    },
    goWajibPajak() {
      this.$refs["modal-wajib-pajak"].showModal();
    },
    goDasarHukum() {
      this.dasar_hukum = true;
    },
    goback() {
      this.$router.go(-1);
    },
    goWajibPajakPendaftaran() {
      this.$router.push("/mineral-bukan-logam-batuan/daftar");
    },
    goSptpdPajak() {
      this.$router.push("/mineral-bukan-logam-batuan/e-sptpd");
    },
    cetakSSPD() {
      this.$router.push("/mineral-bukan-logam-batuan/pembayaran");
    },
  },
};
</script>
<style lang="scss" scoped>
.section-shaped .shape.shape-skew + .shape-container {
  padding-top: 9rem;
  padding-bottom: 14rem;
}

.card-mnlb {
  height: 100%;
}
</style>